import { DateTime } from 'luxon';
import styled from 'styled-components';
import tw from 'twin.macro';
import { useSnapshot } from 'valtio';

import { appNow } from '../../core/appTime';
import { appTimeHasMock, appTimeStore, isDevApiEnv } from '../../../store/appTimeStore';

const Badge = styled.div`
  ${tw`
    fixed
    top-3
    right-3
    z-[9998]
    px-3
    py-2
    rounded-full
    text-xs
    font-bold
    pointer-events-none
    shadow-md
  `}
  background: rgba(185, 28, 28, 0.94);
  color: #fff;
`;

export const MockTimeBadge: React.FC = () => {
  const appTime = useSnapshot(appTimeStore);

  if (!isDevApiEnv() || !appTimeHasMock(appTime)) {
    return null;
  }

  const text = DateTime.fromJSDate(appNow()).toFormat('yyyy/MM/dd h:mm a');

  return <Badge>Mock time: {text}</Badge>;
};
